export enum ERROR_CODE {
  SLOT_NOT_AVAILABLE = "SLN",
  SLOT_NOT_AVAILABLE_ANYMORE = "SLNA",
  PAYMENT_INIT_FAILED = "PIF",
  SOMETHING_WENT_WRONG = "SWR",
  APPOINTMENT_TO_CANCEL_NOT_FOUND = "ATCNF",
  APPOINTMENT_TO_RESCHEDULE_NOT_FOUND = "ATRNF",
  CANCELLATION_NOT_ALLOWED = "CNA",
  WRONG_PATIENT_DETAIL = "WPD",
  DATABASE_ERROR = "DBE",
  APPOINTMENT_NOT_FOUND = "ANF",
  NO_ACCESS = "NC",
  LOW_CREDITS = "LC",
}
